import { render, staticRenderFns } from "./AlterarSenhaTemporaria.vue?vue&type=template&id=1fbca450&scoped=true&"
import script from "./AlterarSenhaTemporaria.vue?vue&type=script&lang=js&"
export * from "./AlterarSenhaTemporaria.vue?vue&type=script&lang=js&"
import style0 from "./AlterarSenhaTemporaria.vue?vue&type=style&index=0&id=1fbca450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbca450",
  null
  
)

export default component.exports